import { Dialog, DialogContent } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import StepperHeader from "./components/StepperHeader";
import StepperFooter from "./components/StepperFooter";

const HyroStepperDialog = (
  {
    open,
    steps,
    handleDone,
    handleCancel,
    hideProgress,
    activeStep,
    setActiveStep,
    dontShowBackButton,
    fullScreen,
    showLogo,
    closeDisabled,
    sx
  }
) => {
  const isFirstStep = activeStep === 0;
  const isLastStep = activeStep === steps.length - 1;
  const {
    component,
    dialogDims,
    heading,
    backDisabled,
    nextDisabled,
    primaryButtonText,
    secondaryButtonText,
    primaryButtonLoading = false,
    handleBack: stepHandleBack,
    handleNext: stepHandleNext
  } = steps[activeStep];

  const handleClickNext = () => {
    if (isLastStep) return handleDone();

    const isNextDisabled = steps[activeStep + 1]?.disabled;

    if (isNextDisabled) {
      // Find next step that is not disabled
      let nextStep = activeStep + 2;

      while (nextStep < steps.length && steps[nextStep].disabled) {
        nextStep++;
      }
      setActiveStep(nextStep);
    } else if (!nextDisabled) {
      setActiveStep(prev => prev + 1);
    }

    stepHandleNext?.();
  };

  const handleClickBack = () => {
    const isBackDisabled = steps[activeStep - 1]?.disabled;

    if (isBackDisabled) {
      // Find previous step that is not disabled
      let prevStep = activeStep - 2;

      while (prevStep >= 0 && steps[prevStep].disabled) {
        prevStep--;
      }
      setActiveStep(prevStep);
    } else {
      setActiveStep(prev => prev - 1);
    }

    stepHandleBack?.();
  };

  return (
    <StyledDialog
      data-testid="hyro-stepper-dialog"
      dialogDims={dialogDims}
      open={open}
      scroll="paper"
      maxWidth="sm"
      fullScreen={fullScreen}
      sx={sx}
    >
      <StepperHeader
        heading={heading}
        handleCancel={handleCancel}
        hideProgress={hideProgress}
        activeStep={activeStep}
        steps={steps}
        showLogo={showLogo}
        closeDisabled={closeDisabled}
      />

      <DialogContent>{component}</DialogContent>

      <StepperFooter
        secondaryButtonText={dontShowBackButton ? "" : secondaryButtonText}
        isSecondaryButtonDisabled={isFirstStep || backDisabled}
        handleBack={handleClickBack}
        isPrimaryButtonLoading={primaryButtonLoading}
        isPrimaryButtonDisabled={nextDisabled}
        primaryButtonText={primaryButtonText}
        handleClickNext={handleClickNext} />
    </StyledDialog>
  );
};

export default HyroStepperDialog;

const StyledDialog = styled(Dialog, {
  shouldForwardProp: prop => prop !== "dialogDims"
})(({ dialogDims }) => ({
  "& .MuiDialog-paper": {
    ...dialogDims || {},
    width: "100%"
  }
}));
